import {ACard, AToggleButtonGroup} from "@atiautomacao/ati-ui-library";
import {Box, Stack, TextField, Typography} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {SimCardDownloadOutlined} from "@mui/icons-material";
import React, {FunctionComponent, useState} from "react";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {endOfDay, isWithinInterval, startOfDay} from "date-fns";
import {LocalDateTimeFormatISO} from "../../../../../Utils/DateFormatPatternUtils";
import HeatMapChartStringCurrent from "./StringChart/HeatMapChartStringCurrent";
import LineChartStringCurrent from "./StringChart/LineChartStringCurrent";

const StringComponent: FunctionComponent<{  equipmentId: number}> = ({equipmentId}) => {
    const [date, setDate] = useState<Date>(startOfDay(new Date()));
    const [prValue, setPrValue] = React.useState("0");

    const handleChangePR =  (_: React.MouseEvent<HTMLElement>, value: string | null) => {
        setPrValue(value ?? "0");
    };

    return (
        <ACard
            title="Corrente de Strings"
            ariaLabel={"dashboard-station-inverter-string-current"}
            key={`dashboard-station-inverter-string-current`}
            styleProps={{
                cardStyle: { minHeight: 500, height: 'auto' },
                contentStyle: { padding: '0 16px', height: 'auto',  alignItems: 'center', display: 'block'},
                titleStyle: { alignItems: 'center', display: 'flex' },
                subTitleStyle: { display: 'none' },

            }}
            headerControlsPosition={"header"}
            headerControls={
                <Box  sx={{ display: 'flex', alignItems: 'center', gap: 2, flexDirection: 'row', marginBottom: '3%'}}>
                    <AToggleButtonGroup
                        styleProps={{
                            toggleButtonGroup: {
                                marginLeft: 2,
                                paddingLeft: '4px',
                                height: '30px',
                            },
                            toggleButton: {
                                height: '30px',
                            },
                            typography: {
                                fontSize: '14px',
                            },
                        }}
                        options={[
                            { value: "0", label: 'MAPA DE CALOR' },
                            { value: "1", label: 'GRÁFICO' },
                        ]}
                        value={prValue}
                        exclusive
                        onChange={handleChangePR}

                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}
                    >
                        <DatePicker
                            label="Dia"
                            renderInput={(params) => <TextField
                                sx={{  '& .MuiOutlinedInput-root':
                                        { borderRadius: '8px', color: 'gray', height: '30px', width: '155px' } }} {...params} />}
                            value={date}
                            inputFormat={"DD/MM/YYYY"}
                            onChange={(newValue) => {
                                if (newValue && isWithinInterval(new Date(newValue), { start: new Date('1980-01-01'), end: endOfDay(new Date()) })) {
                                    setDate(startOfDay(new Date(LocalDateTimeFormatISO(newValue))));
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            }
            headerActions={
                <Stack direction="column" spacing={"8px"}>
                    <Box sx={{ display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 12px'}}>
                        <IconButton disabled={true} size="small" >
                            <SimCardDownloadOutlined sx={{marginRight: '12px'}}/>
                            <Typography variant="body2">Baixar como CSV</Typography>
                        </IconButton>
                    </Box>
                </Stack>
            }
        >
            { prValue === "0" ?
                <HeatMapChartStringCurrent equipmentId={equipmentId} date={date}/>
                :
                <LineChartStringCurrent equipmentId={equipmentId} date={date}/>
            }
        </ACard>
    )
}

export default StringComponent;